import './wordEnding';
import  './formatNumber';